// eslint-disable-next-line import/prefer-default-export
export const RequestAction = Object.freeze({
    Approve: 0,
    Pending: 1,
    Refuse: 2,
});
